import { render } from "./uploadForm.vue?vue&type=template&id=26e02678"
import script from "./uploadForm.vue?vue&type=script&lang=js"
export * from "./uploadForm.vue?vue&type=script&lang=js"

import "./uploadForm.vue?vue&type=style&index=0&id=26e02678&lang=css"
script.render = render

export default script